import React, { useState, useRef, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import {Link} from 'react-router-dom'
import {FaCartArrowDown} from 'react-icons/fa'

const Navbar = () => {
  const [showLinks, setShowLinks] = useState(false);
  const linksContainerRef = useRef(null);
  const linksRef = useRef(null);
  const toggleLinks = () => {
    setShowLinks(!showLinks);
  };
  useEffect(() => {
    const linksHeight = linksRef.current.getBoundingClientRect().height;
    if (showLinks) {
      linksContainerRef.current.style.height = `${linksHeight}px`;
    } else {
      linksContainerRef.current.style.height = '0px';
    }
  }, [showLinks]);
  return (
    <nav>
      <div className='nav-center'>
        <div className='nav-header'>
        <Link className="link" to='/'><h3 style={{color:'white',fontSize:'1.75rem'}}>audiophile</h3></Link>
          <button className='nav-toggle' onClick={toggleLinks}>
          <FaBars style={{color:'white'}} />
          </button>
        </div>
        <div className='links-container' ref={linksContainerRef}>
        <ul className="links" ref={linksRef}>
                            <li>
                                <Link className="link" style={{color:'white'}} to='/'>Home</Link>
                            </li>
                            <li>
                                <Link className="link" style={{color:'white'}}  to='/headphone'>Headphones</Link>
                            </li>
                            <li>
                                <Link className="link" style={{color:'white'}} to='/speaker'>Speakers</Link>
                            </li>
                            <li>
                                <Link className="link" style={{color:'white'}} to='/earphone'>Earphones</Link>
                            </li>
                            <li>
                            <Link className='link' style={{color:'white'}} to='/cart'>Cart</Link>
                            </li>
                        </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
